import platform from '../config/platform.ts';

/**
 * FNP-864. Single enforcement point for redirect-target validation.
 *
 * The portal hands raw Cognito tokens to other platform apps in a URL
 * fragment, so the redirect target is the only thing standing between a
 * signed-in user and an attacker-controlled origin receiving their tokens.
 *
 * Every site that builds such a URL MUST call this, and MUST call it on the
 * value it is about to use — not on the value it once validated. Cached
 * values are untrusted input: the cache is written before the user has
 * authenticated, so an unauthenticated visitor can seed it.
 *
 * Matching is an EXACT string comparison against the known app origins in
 * `config/platform.ts`. Deliberately not `startsWith`, `includes`, or any
 * prefix/substring test — those admit `https://portal.flexi.network.evil.com`
 * and `https://evil.com?x=https://portal.flexi.network`.
 */
export const isAllowedRedirectUrl = (url: unknown): url is string => {
    if (typeof url !== 'string' || url === '') {
        return false;
    }

    return Object.values(platform).includes(url);
};
